import { request } from "../../api";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
import { HealthLink } from "../../../../types/healthLink.types";

const { get } = request;
const { Bearer } = AUTHORIZATION;
const initialRoute = "blogs";

export const getHealthLinkByGroupNumber = async (group_number: number): Promise<HealthLink[]> => {
	try {
		const endpoint = `${initialRoute}/group-number/${group_number}`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(endpoint, {
			Authorization: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				// console.log("result", result);
				return result;
			} else if (message === MESSAGE.get.empty) {
				return [];
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getHealthLinkByGroupNumberAndLocationNumber = async ({
	group_number,
	location_number
}: {
	group_number: number;
	location_number?: number;
}): Promise<HealthLink[]> => {
	try {
		const endpoint = `${initialRoute}/group-number/${group_number}?location_number=${location_number}`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(endpoint, {
			Authorization: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				// console.log("result", result);
				return result;
			} else if (message === MESSAGE.get.empty) {
				return [];
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const healthLinks = {
	getHealthLinkByGroupNumber,
	getHealthLinkByGroupNumberAndLocationNumber
};
